import React from "react";
import { CurrentUser } from "../models/CurrentUser";

export const UserContextDefault: UserContextObject = {
    user: undefined
}
export const UserContext = React.createContext<UserContextObject>(UserContextDefault);

export interface UserContextObject { user: CurrentUser | undefined }